export default "__VITE_ASSET__wxecVm0T__"